// Persist & retrieve referral code across the OAuth roundtrip.
const KEY = "corp_ref";

export function captureReferralFromURL() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const ref = (params.get("ref") || "").trim().toUpperCase();
  if (ref) {
    try {
      window.localStorage.setItem(KEY, ref);
    } catch (e) {
      // ignore
    }
    return ref;
  }
  return null;
}

export function getStoredReferral() {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(KEY);
  } catch (e) {
    return null;
  }
}

export function clearStoredReferral() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY);
  } catch (e) {
    // ignore
  }
}
